import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgFileSecurity = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M15.41 2 20 6.59V8h-6V4H6v16h12V10h2v12H4V2h11.41Z"
    />
    <path
      fill="#88827E"
      d="M16 10H8v3.492c0 3.256 2.058 4.552 4 5.508 1.947-.956 4-2.252 4-5.508V10Zm-4.222 5.42-1.427-1.4.631-.62.796.781 1.684-1.654.627.616-2.311 2.278Z"
    />
  </svg>
);
export default SvgFileSecurity;
